<div class="map-tile-container  gridster-item-content">
    <div *ngIf="!isMapTileEnabled" class="center">
        <div class="center_text">
            {{turnOffMapTileMsg}}
        </div>
    </div>
    <div *ngIf="isMapTileEnabled" class="map-container">
        <tam-dashboard-map-autocomplete *ngIf="!isPrintMode" [hidden]="isShowNearby||(isMapShow && isTripShow)"
            class="autocomplete" [config]="mapConfig" (eventSubject$)="setSelectedAddress($event)">
        </tam-dashboard-map-autocomplete>
        <tam-dashboard-map-trip [hidden]="isShowNearby" [destinationConfig]="selectedMapContact"
            (eventSubject$)="eventHandler($event)" class="trip-autocomplete" *ngIf="isTripShow" [id]="id">
        </tam-dashboard-map-trip>
        <smart-icon *ngIf="!isMapShow && !isLoading" class="map-tile-icon" name="map-tile"></smart-icon>

        <div [hidden]="!isMapShow" class="map-container" loading-spin [isLoading]="isLoading" [loadingSize]="'big'"
            [loadingTransparent]="true">
            <tam-dashboard-map [config]="mapConfig" [id]="id" [isShowEventOnMap]="isShowEventOnMap"></tam-dashboard-map>
        </div>

    </div>
    <tam-dashboard-map-nearby class="nearby" *ngIf="isShowNearby" (eventSubject$)="setSelectedAddress($event)"
        [location]="location" [id]="id" [isFromShowEventOnMapTile]="isFromShowEventOnMapTile">
    </tam-dashboard-map-nearby>
</div>